@layer base-components {
    // Flex, so the target is exactly the avatar's box (see AvatarTooltip).
    .target {
        display: inline-flex;
    }
}
